import { createSelector } from 'reselect';
import { preAssessmentDetails } from '@/selectors/merchant';
import { getCountries } from '@/selectors/options';

export const getDefaultState = createSelector(
  getCountries,
  preAssessmentDetails,
  (countries, { sellingCountries }) => {
    if (sellingCountries && sellingCountries.all) {
      return {
        countries: sellingCountries.all.map(key => countries.find(c => c.key === key)),
        selected: sellingCountries.main,
      };
    }
    return { countries: [], selected: null };
  },
);
